export default __webpack_public_path__ + "static/media/featured.4c160afb.svg";